import { render } from "./Sync.vue?vue&type=template&id=d81020ca"
const script = {}

import exportComponent from "/Users/zenet/works/cashb_marketing/dockerfiles/vue/web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__